import React from 'react';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import FacetPlanAddBalanceTransfer from 'Views/Page/Content/Modal/Layouts/FacetPlanAddBalanceTransfer';

const AddFacetPlanBalanceTransfer = () => {
  const { clearModalCollection } = useModalContext();

  const onSubmit = async () => {
    clearModalCollection();
  };

  return (
    <FacetPlanAddBalanceTransfer onSubmit={onSubmit} />
  );
};

AddFacetPlanBalanceTransfer.defaultProps = {
};

AddFacetPlanBalanceTransfer.propTypes = {
};

export default AddFacetPlanBalanceTransfer;
